import React, { useState } from 'react';
import { ChevronDown, HelpCircle } from 'lucide-react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'What services does Made in Heaven provide?',
      answer: 'We offer complete event planning and management services including wedding planning, corporate events, birthday parties, anniversaries, engagement ceremonies, venue coordination, vendor management, decoration, and on-day execution. We handle everything from concept to completion.'
    },
    {
      question: 'How much experience do you have in event planning?',
      answer: 'Our founder, Anant Singh, brings over 12 years of experience in event planning and management. We have successfully delivered 500+ events across Vadodara and Gujarat, earning the trust of over 1000 happy clients.'
    },
    {
      question: 'Do you only plan weddings or other events too?',
      answer: 'We plan all types of events including weddings, engagements, haldi, mehendi, sangeet, birthdays, anniversaries, baby showers, corporate events, product launches, conferences, and family celebrations. No event is too big or too small.'
    },
    {
      question: 'What areas do you serve?',
      answer: 'We are based in Vadodara and primarily serve Vadodara, Anand, Bharuch, Surat, and surrounding areas across Gujarat. We can also coordinate destination events within and outside Gujarat.'
    },
    {
      question: 'How far in advance should I book your services?',
      answer: 'For weddings, we recommend booking 6-12 months in advance. For other events, 2-3 months is ideal. However, we can work with shorter timelines depending on availability and event requirements.'
    },
    {
      question: 'Do you provide customized packages?',
      answer: 'Yes, absolutely. We understand every event and budget is different. We create personalized packages based on your specific requirements, preferences, and budget. We offer flexible, practical pricing without compromising on quality.'
    },
    {
      question: 'Will you handle vendor coordination?',
      answer: 'Yes, vendor coordination is one of our core services. We work with trusted vendors for catering, photography, decoration, entertainment, and more. We handle all coordination, contracts, and on-day management so you don\'t have to worry.'
    },
    {
      question: 'What makes Made in Heaven different from other event planners?',
      answer: 'We combine 12+ years of experience with deep understanding of Gujarati traditions and modern trends. We offer personalized service, practical pricing, stress-free planning, professional coordination, and hands-on care from start to finish. Our goal is for you to enjoy your celebration while we handle the pressure.'
    },
    {
      question: 'Do you provide decoration and styling services?',
      answer: 'Yes, we provide complete decoration and styling services including floral arrangements, lighting design, stage setups, theme-based decor, and full venue transformation tailored to your vision and budget.'
    },
    {
      question: 'How do I get started?',
      answer: 'Simply contact us through our website, phone, or WhatsApp. We\'ll schedule a consultation to discuss your event, understand your vision, and provide a customized plan and quote. There\'s no obligation - we\'re happy to answer your questions and help you plan.'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 md:py-32 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          
          {/* Header */}
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 text-amber-600 mb-4">
              <HelpCircle size={32} />
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              Frequently Asked Questions
            </h2>
            <p className="text-lg text-gray-600">
              Everything you need to know about our event planning services
            </p>
          </div>

          {/* FAQ List */}
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl shadow-md hover:shadow-lg transition-shadow duration-300 overflow-hidden"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full text-left p-6 flex justify-between items-center gap-4 hover:bg-gray-50 transition-colors duration-200"
                >
                  <span className="font-semibold text-gray-900 text-base md:text-lg pr-4">
                    {faq.question}
                  </span>
                  <ChevronDown
                    size={24}
                    className={`text-amber-600 flex-shrink-0 transition-transform duration-300 ${
                      openIndex === index ? 'transform rotate-180' : ''
                    }`}
                  />
                </button>
                
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === index ? 'max-h-96' : 'max-h-0'
                  }`}
                >
                  <div className="px-6 pb-6 text-gray-700 leading-relaxed">
                    {faq.answer}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Bottom CTA */}
          <div className="mt-12 text-center p-8 bg-amber-50 rounded-2xl border border-amber-200">
            <p className="text-lg text-gray-700 mb-4">
              <strong className="text-gray-900">Still have questions?</strong> We're here to help!
            </p>
            <p className="text-gray-600">
              Contact us at <a href="tel:+919638063350" className="text-amber-700 font-semibold hover:underline">+91 96380 63350</a> or{' '}
              <a href="mailto:Singhanant198@gmail.com" className="text-amber-700 font-semibold hover:underline">email us</a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;